import { combineReducers } from 'redux';
import { REHYDRATE } from 'redux-persist/constants';
import {
  fetchProfile,
  fetchPassport,
  fetchAddress,
  fetchPassportAddress,
  postProfile,
  postPassport,
  postAddress,
  postPassportAddress,
  fetchVehicles,
  postVehicle,
  fetchConfidants,
} from '../sagas/settings/actions';
import { register } from '../sagas/auth/actions';
import { logoutButtonClick } from '../components/Auth/actions';
import { toggleSettingsModal, changeCurrentVehicle, switchCurrentDevice } from '../components/Modal/actions';
import { changeCurrentDevice } from '../components/Header/actions';
import { fetchDevices } from '../sagas/devices/actions';
import { editDeviceNameSave } from '../components/Modal/SettingsModal/VehiclesSettings/actions';

const profile = (state = {}, action) => {
  if (action.type === fetchProfile.done.type || action.type === postProfile.done.type) {
    return action.payload.result;
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const profileErrorCode = (state = null, action) => {
  if (action.type === fetchProfile.failed.type) {
    return action.payload.error.status;
  }

  if (action.type === fetchProfile.done.type || action.type === postProfile.done.type) {
    return null;
  }

  return state;
};

const profileErrors = (state = [], action) => {
  if (action.type === postProfile.failed.type) {
    return Object.keys(action.payload.error).map(k => k.toLowerCase());
  }

  if (action.type === postProfile.done.type) {
    return [];
  }

  return state;
};

const passport = (state = {}, action) => {
  if (action.type === fetchPassport.done.type || action.type === postPassport.done.type) {
    const passportData = action.payload.result;
    const date = passportData.issueDate;
    if (date) {
      passportData.issueDate = `${date.day}.${date.month}.${date.year}`;
    }

    return passportData;
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const passportErrors = (state = [], action) => {
  if (action.type === postPassport.failed.type) {
    return Object.keys(action.payload.error).map(k => k.toLowerCase());
  }

  if (action.type === postPassport.done.type) {
    return [];
  }

  return state;
};

const passportErrorCode = (state = null, action) => {
  if (action.type === fetchPassport.failed.type) {
    return action.payload.error.status;
  }

  if (action.type === fetchPassport.done.type || action.type === postPassport.done.type) {
    return null;
  }

  return state;
};

const address = (state = {}, action) => {
  if (action.type === fetchAddress.done.type || action.type === postAddress.done.type) {
    return action.payload.result;
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const addressErrorCode = (state = null, action) => {
  if (action.type === fetchAddress.failed.type) {
    return action.payload.error.status;
  }

  if (action.type === fetchAddress.done.type || action.type === postAddress.done.type) {
    return null;
  }

  return state;
};

const addressErrors = (state = [], action) => {
  if (action.type === postAddress.failed.type) {
    return Object.keys(action.payload.error).map(k => k.toLowerCase());
  }

  if (action.type === postAddress.done.type) {
    return [];
  }

  return state;
};

const passportAddress = (state = {}, action) => {
  if (action.type === fetchPassportAddress.done.type || action.type === postPassportAddress.done.type) {
    return action.payload.result;
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const passportAddressErrorCode = (state = null, action) => {
  if (action.type === fetchPassportAddress.failed.type) {
    return action.payload.error.status;
  }

  if (action.type === fetchPassportAddress.done.type || action.type === postPassportAddress.done.type) {
    return null;
  }

  return state;
};

const passportAddressErrors = (state = [], action) => {
  if (action.type === postPassportAddress.failed.type) {
    return Object.keys(action.payload.error).map(k => k.toLowerCase());
  }

  if (action.type === postPassportAddress.done.type) {
    return [];
  }

  return state;
};

const vehicles = (state = [], action) => {
  if (action.type === fetchVehicles.done.type) {
    const deviceId = JSON.parse(action.payload.params.body).deviceId;
    return [...state, ...action.payload.result.data.map(i => {
      i.deviceId = deviceId;
      return i;
    })];
  }

  if (action.type === logoutButtonClick.type) {
    return [];
  }

  if (action.type === postVehicle.done.type) {
    return [
      ...state,
      action.payload.result,
    ];
  }

  return state;
};

const vehiclesErrorCode = (state = null, action) => {
  if (action.type === fetchVehicles.failed.type) {
    return action.payload.error.status;
  }

  if (action.type === fetchVehicles.done.type) {
    return null;
  }

  return state;
};

const vehiclesErrors = (state = [], action) => {
  if (action.type === postVehicle.failed.type) {
    return Object.keys(action.payload.error).map(k => k.toLowerCase());
  }

  if (action.type === postVehicle.done.type) {
    return [];
  }

  return state;
};

const settingsType = (state = 'profile', action) => {
  if (action.type === toggleSettingsModal.type) {
    return action.payload.type;
  }

  return state;
};

const currentVehicle = (state = {}, action) => {
  if (action.type === changeCurrentVehicle.type) {
    return action.payload.vehicle;
  }

  if (action.type === fetchVehicles.done.type) {
    return action.payload.result.data[0] || {};
  }

  return state;
};

const currentDevice = (state = null, action) => {
  if (action.type === switchCurrentDevice.type) {
    return action.payload.device;
  }

  if (action.type === changeCurrentDevice.type) {
    return action.payload.device;
  }

  if (action.type === REHYDRATE) {
    if (action.payload.devices && action.payload.devices.currentDevice) {
      return action.payload.devices.currentDevice;
    }
    return state;
  }

  if (action.type === fetchDevices.done.type) {
    if (action.payload.result.data.length && !state) return action.payload.result.data[0];
    return state;
  }

  if (action.type === editDeviceNameSave.type) {
    const { deviceId, name } = action.payload;
    return state.id === deviceId
      ? {
        ...state,
        name,
      }
      : state;
  }

  return state;
};

const packageId = (state = null, action) => {
  if (action.type === register.done.type) {
    const params = JSON.parse(action.payload.params.body);
    localStorage.setItem('packageId', params.packageId);
    return params.packageId;
  }

  return state;
};

const confidants = (state = [], action) => {
  if (action.type === fetchConfidants.done.type) {
    const deviceId = JSON.parse(action.payload.params.body).deviceId;
    return [...state, ...action.payload.result.data.map(i => {
      i.deviceId = deviceId;
      return i;
    })];
  }

  return state;
};

export default combineReducers({
  profile,
  profileErrorCode,
  profileErrors,
  passport,
  passportErrorCode,
  passportErrors,
  address,
  addressErrorCode,
  addressErrors,
  passportAddress,
  passportAddressErrorCode,
  passportAddressErrors,
  vehicles,
  vehiclesErrorCode,
  vehiclesErrors,
  currentVehicle,
  currentDevice,
  settingsType,
  packageId,
  confidants,
});



// WEBPACK FOOTER //
// ./src/reducers/settings.js